import React from 'react';
import classNames from 'classnames';

export default function WarningMessage({
  className,
  children,
  isWarning,
  dataTestId,
  hidePrefix,
  isDelivery
}) {
  return (
    <div
      className={classNames('alert fade show', className, {
        'alert-warning': isWarning,
        'alert-danger': !isWarning,
        'alert-dismissible': !isDelivery
      })}
      role="alert"
      data-test-id={dataTestId}>
      <p className="m-0">
        {hidePrefix || <strong>Warning:</strong>} {children}
      </p>
    </div>
  );
}
